import { Injectable } from '@angular/core';
import { RoutesUtil } from './RoutesUtil';

interface PublicApiEntry {
    url: string;
    methods: string[];
    regex?: RegExp;
}

@Injectable({
    providedIn: 'root',
})
export class PublicApiUtil {
    private _publicApis: PublicApiEntry[];

    constructor(private readonly routerUtils: RoutesUtil) {
        this.setPublicApis();
    }

    private setPublicApis(): void {
        const apiList: Omit<PublicApiEntry, 'regex'>[] = [
            {
                url: `${this.routerUtils.initSsoAccount()}`,
                methods: ['POST'],
            },
            {
                url: this.routerUtils.getCsrfToken(),
                methods: ['POST'],
            },
            {
                url: this.routerUtils.getUsersUrl(),
                methods: ['POST'],
            },
            {
                url: this.routerUtils.getResendVerificationMailUrl(),
                methods: ['POST'],
            },
            {
                url: this.routerUtils.getResetPasswordRoute(),
                methods: ['POST'],
            },
            {
                url: this.routerUtils.getLocalizationRoute(),
                methods: ['GET'],
            },
            {
                url: `${this.routerUtils.getInvitationByUuid('$uuid/')}`,
                methods: ['GET'],
            },
            {
                url: `${this.routerUtils.acceptInvitation('$uuid/')}`,
                methods: ['PATCH'],
            },
            {
                url: `${this.routerUtils.getSupportedLocales()}`,
                methods: ['GET'],
            },
            {
                url: `${this.routerUtils.getSsoProvider('$handle') + '/'}`,
                methods: ['GET'],
            },
            {
                url: `${this.routerUtils.startSsoUrl('$handle') + '/'}`,
                methods: ['GET'],
            },
            {
                url: `${this.routerUtils.exchangeSsoCodeWithToken('$handle')}`,
                methods: ['POST'],
            },
        ];

        this._publicApis = apiList.map((entry) => {
            if (entry.url.includes('$')) {
                const regexPattern = entry.url.replace(/\$[^/]+/g, '([^/]+)');
                return {
                    ...entry,
                    regex: new RegExp(`^${regexPattern}$`),
                };
            }
            return entry;
        });
    }

    get publicApis(): PublicApiEntry[] {
        return this._publicApis;
    }
}
